import { createFileRoute } from "@tanstack/react-router";
import { Shell } from "@/components/control-tower/Layout";
import { FindingsList } from "@/components/building/findings/FindingsList";
import {
  useScopedFindings,
  type FindingsPerspective,
} from "@/lib/api/useScopedFindings";
import { useScopedNavigate } from "@/lib/scoped-nav";
import { findingsSearchSchema } from "@/lib/findings-search-schema";
import {
  entityKindForFindingsPerspective,
  findingsPerspectiveForEntityKind,
  type EntityKind,
} from "@/lib/entity-kind";

export const Route = createFileRoute("/findings")({
  validateSearch: findingsSearchSchema,
  component: FindingsPage,
});

function FindingsPage() {
  const { category, source, finding } = Route.useSearch();
  const navigate = useScopedNavigate();
  const perspective: FindingsPerspective = { category, sourceType: source };
  const { findings, loading, onAcknowledged } = useScopedFindings(perspective);
  const activeEntityKind = entityKindForFindingsPerspective(perspective);

  function handleEntityKindChange(kind: EntityKind | "all") {
    const next = findingsPerspectiveForEntityKind(kind);
    void navigate({
      to: ".",
      search: (prev) => ({
        ...prev,
        category: next.category,
        source: next.sourceType,
      }),
    });
  }

  return (
    <Shell
      title="Havainnot"
      subtitle="Avoimet havainnot · järjestys: kriittiset ensin"
    >
      <FindingsList
        findings={findings ?? []}
        loading={loading}
        onAcknowledged={onAcknowledged}
        showEntityKindFilter
        entityKind={activeEntityKind}
        onEntityKindChange={handleEntityKindChange}
        openFindingId={finding}
      />
    </Shell>
  );
}
